/* TOPNAVI · tn-brand-video.js — bemutató videó (sections/tn-brand-details.liquid, snippets/tn-video-hero.liquid) · v5 2026-09-19
   1) videó-hero: natív <video> vagy YouTube (IFrame API; ha az API 15 s alatt nem jön, sima iframe-beágyazás postMessage-
      vezérléssel) — némán, saját hangkapcsoló; kattintásra megáll/indul.
      POSZTER-LOGIKA (v5 — tulaj: „rögtön induljanak, ahogy ott tart az oldal"): a középső szünet-ikont a PROGRAMOZOTT indítás
      (playVideo) villantja, ezért a lejátszó most saját autoplayjel indul (autoplay=1, némán), playVideo-t csak akkor küldünk,
      ha 2,5 s alatt magától nem indult el. A lejátszó a látótér előtt 1400 px-szel jön létre, a felfedés küszöbe 12%, a
      biztonsági várakozás 3,6 s helyett 0,7 s — így a szakasz a képernyőre érve már futó videót mutat. Kigörgetve NEM állítjuk meg (30 s után igen), hogy visszagörgetve ne
      induljon újra az ikon. Felhasználói újraindításnál azonnal felfedjük (ő kattintott, az ikon természetes).
      Állapot: [data-tn-vh-state] = idle|loading|ready|playing|paused|fallback|error (hibakereséshez).
   2) „kosárba" gomb → buy box; beágyazva (Android-lapon ajaxszal) a „vissza" és a „saját oldal" linkek látszanak.
   Fut: a szett saját oldalán és az Android-lapon injektálva (product-pioneer-alt → TNBrand.init), és minden önálló
   [data-tn-vh]-n (tn-video-hero a sima terméklapokon). */
(function () {
  'use strict';
  var reduce = false, saveData = false;
  try { reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  try { saveData = !!(navigator.connection && navigator.connection.saveData); } catch (e) {}
  var autoplayOK = !reduce && !saveData;
  var YT_HOST = 'https://www.youtube-nocookie.com';
  var ICON_MS = 700;    /* 2026-09-19: a lejátszó magától indul (autoplay=1), így nincs API-ripple — csak rövid biztonsági idő */
  var PREROLL = 1400;   /* ennyivel a látótér előtt hozzuk létre és indítjuk a lejátszót a poszter mögött */
  var GRACE_MS = 2500;  /* eddig NEM küldünk playVideo-t: hagyjuk magától elindulni (a programozott indítás villantja az ikont) */
  var AWAY_MS = 30000;  /* ennyi kigörgetett idő után állítjuk meg */

  var ytPromise = null;
  function loadYT() {
    if (window.YT && window.YT.Player) return Promise.resolve();
    if (ytPromise) return ytPromise;
    ytPromise = new Promise(function (resolve, reject) {
      /* Nem csak az onYouTubeIframeAPIReady-re várunk (más script felülírhatja), hanem 100 ms-onként nézzük a YT.Player-t is. */
      var done = false, t0 = Date.now();
      function ok() { if (done) return; done = true; clearInterval(poll); resolve(); }
      var prev = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = function () { if (typeof prev === 'function') { try { prev(); } catch (e) {} } ok(); };
      var poll = setInterval(function () {
        if (window.YT && window.YT.Player) ok();
        else if (Date.now() - t0 > 15000) { clearInterval(poll); if (!done) { done = true; reject(new Error('yt api timeout')); } }
      }, 100);
      if (![].some.call(document.scripts, function (x) { return (x.src || '').indexOf('youtube.com/iframe_api') > -1; })) {
        var s = document.createElement('script');
        s.src = 'https://www.youtube.com/iframe_api';
        s.async = true;
        s.onerror = function () { clearInterval(poll); if (!done) { done = true; reject(new Error('yt api blocked')); } };
        document.head.appendChild(s);
      }
    });
    ytPromise.catch(function () { ytPromise = null; });
    return ytPromise;
  }

  function initHero(vh) {
    if (vh.__tnVh) return;
    vh.__tnVh = true;
    var video = vh.querySelector('[data-tn-vh-video]');
    var frame = vh.querySelector('[data-tn-vh-frame]');
    var ytId = vh.getAttribute('data-tn-vh-yt') || '';
    if (!video && !(frame && /^[\w-]{6,20}$/.test(ytId))) return;

    var soundBtn = vh.querySelector('[data-tn-vh-sound]');
    var soundLbl = vh.querySelector('[data-tn-vh-sound-label]');
    var playBtn = vh.querySelector('[data-tn-vh-play]');
    var ctl = null, creating = null;
    /* 2026-09-20: [data-tn-vh-noauto] → a videó csak kattintásra indul */
    var noAuto = vh.hasAttribute('data-tn-vh-noauto');
    var visible = false, wanted = autoplayOK && !noAuto, playing = false, userPaused = noAuto, awayLong = false;
    var startedAt = 0, forceReveal = false, retries = 0, retryTimer = null, revealTimer = null, awayTimer = null;
    var autoStartAt = 0; /* mikor jött létre a lejátszó saját autoplayjel — addig nem hívunk playVideo-t */
    var isYT = !video;
    function state(s) { vh.setAttribute('data-tn-vh-state', s); }
    state('idle');

    function scheduleReveal() {
      clearTimeout(revealTimer);
      if (!playing || !visible) return;
      var wait = isYT && !forceReveal ? Math.max(0, ICON_MS - (Date.now() - startedAt)) : 0;
      forceReveal = false;
      revealTimer = setTimeout(function () { if (playing && visible) vh.classList.add('is-playing'); }, wait);
    }
    function onPlaying() {
      playing = true; retries = 0;
      if (!startedAt) startedAt = Date.now();
      state('playing');
      vh.classList.remove('is-user-paused');
      if (soundBtn) soundBtn.hidden = false;
      if (playBtn) playBtn.hidden = true;
      scheduleReveal();
    }
    function onPaused() {
      playing = false; startedAt = 0;
      state(ctl ? 'paused' : 'idle');
      clearTimeout(revealTimer);
      vh.classList.remove('is-playing');
    }
    function setSound(on) {
      if (!ctl) return;
      ctl.setMuted(!on);
      if (soundBtn) {
        soundBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
        soundBtn.setAttribute('aria-label', on ? 'Hang kikapcsolása' : 'Hang bekapcsolása');
      }
      if (soundLbl) soundLbl.textContent = on ? 'Hang ki' : 'Hang be';
    }
    function sync() {
      if (!ctl) return;
      clearTimeout(retryTimer);
      if (userPaused) { ctl.pause(); return; }
      if (wanted && !document.hidden && (visible || !awayLong)) {
        if (!playing) {
          /* a saját autoplay indulására várunk; csak ha az nem jön be, küldünk playVideo-t */
          if (autoStartAt && !userPaused && Date.now() - autoStartAt < GRACE_MS) {
            retryTimer = setTimeout(function () { if (!playing) sync(); }, 400);
            return;
          }
          ctl.play();
          /* ha 1,5 s múlva sem megy (a lejátszó még nem volt kész), újra próbáljuk — max. 10× */
          retryTimer = setTimeout(function () { if (!playing && retries < 10) { retries++; sync(); } }, 1500);
        } else {
          scheduleReveal();
        }
      } else {
        ctl.pause();
      }
    }

    function sizeYT(ifr) {
      /* cover-méret + túlméretezés: a YouTube fejléce (felül) és logója (jobbra lent) a keret szélén kívülre esik */
      var w = vh.clientWidth, h = vh.clientHeight;
      var pad = Math.max(64, h * 0.13);
      var s = (h + 2 * pad) / h;
      var iw = Math.max(w, h * 16 / 9) * s, ih = Math.max(h, w * 9 / 16) * s;
      ifr.style.width = Math.ceil(iw) + 'px';
      ifr.style.height = Math.ceil(ih) + 'px';
    }
    function makeFallback() {
      /* sima beágyazás: vezérlés postMessage-dzsel (enablejsapi) — loop/playlist nélkül (a lista-mód ikonsort mutat) */
      state('fallback');
      var ifr = document.createElement('iframe');
      var q = 'autoplay=1&mute=1&controls=0&rel=0&playsinline=1&iv_load_policy=3&disablekb=1&fs=0&enablejsapi=1&origin=' + encodeURIComponent(window.location.origin);
      ifr.src = YT_HOST + '/embed/' + encodeURIComponent(ytId) + '?' + q;
      ifr.setAttribute('allow', 'autoplay; encrypted-media');
      ifr.setAttribute('tabindex', '-1');
      ifr.setAttribute('aria-hidden', 'true');
      ifr.setAttribute('title', 'Bemutató videó (háttér)');
      frame.appendChild(ifr);
      sizeYT(ifr);
      window.addEventListener('resize', function () { sizeYT(ifr); });
      function cmd(f, a) { try { ifr.contentWindow.postMessage(JSON.stringify({ event: 'command', func: f, args: a || [] }), '*'); } catch (e) {} }
      window.addEventListener('message', function (e) {
        if (e.source !== ifr.contentWindow) return;
        var d; try { d = typeof e.data === 'string' ? JSON.parse(e.data) : e.data; } catch (x) { return; }
        if (d && d.event === 'onReady') { sync(); return; }
        if (!d || d.event !== 'infoDelivery' || !d.info) return;
        if (d.info.playerState === 1) onPlaying();
        else if (d.info.playerState === 2 || d.info.playerState === 5) onPaused();
        else if (d.info.playerState === 0) { onPaused(); cmd('seekTo', [0, true]); cmd('playVideo'); }
      });
      return new Promise(function (resolve) {
        ifr.addEventListener('load', function () {
          cmd('listening');
          cmd('mute');
          ctl = { play: function () { cmd('playVideo'); }, pause: function () { cmd('pauseVideo'); }, setMuted: function (m) { cmd(m ? 'mute' : 'unMute'); } };
          autoStartAt = Date.now();
          resolve();
        });
      });
    }
    function create() {
      if (ctl || creating) return creating || Promise.resolve();
      state('loading');
      if (video) {
        video.muted = true;
        video.addEventListener('playing', onPlaying);
        video.addEventListener('pause', onPaused);
        ctl = {
          play: function () { var p = video.play(); if (p && p.catch) p.catch(function () { if (playBtn) playBtn.hidden = false; state('error'); }); },
          pause: function () { video.pause(); },
          setMuted: function (m) { video.muted = m; }
        };
        state('ready');
        creating = Promise.resolve();
        return creating;
      }
      creating = loadYT().then(function () {
        return new Promise(function (resolve) {
          var host = document.createElement('div');
          frame.appendChild(host);
          var player = new window.YT.Player(host, {
            host: YT_HOST,
            videoId: ytId,
            /* loop+playlist NÉLKÜL: a lejátszási lista-mód indításkor előző/következő ikonokat is mutat; a ciklus az ENDED-nél */
            playerVars: { autoplay: 1, controls: 0, rel: 0, playsinline: 1, mute: 1, iv_load_policy: 3, disablekb: 1, fs: 0, modestbranding: 1, origin: window.location.origin },
            events: {
              onReady: function () {
                var ifr = player.getIframe();
                ifr.setAttribute('tabindex', '-1');
                ifr.setAttribute('aria-hidden', 'true');
                ifr.setAttribute('title', 'Bemutató videó (háttér)');
                sizeYT(ifr);
                window.addEventListener('resize', function () { sizeYT(ifr); });
                player.mute();
                ctl = {
                  play: function () { player.playVideo(); },
                  pause: function () { player.pauseVideo(); },
                  setMuted: function (m) { if (m) player.mute(); else player.unMute(); }
                };
                state('ready');
                autoStartAt = Date.now();
                resolve();
              },
              onStateChange: function (e) {
                if (e.data === window.YT.PlayerState.PLAYING) onPlaying();
                if (e.data === window.YT.PlayerState.PAUSED || e.data === window.YT.PlayerState.CUED) onPaused();
                if (e.data === window.YT.PlayerState.ENDED) { onPaused(); player.seekTo(0, true); player.playVideo(); }
              },
              onError: function () { state('error'); if (playBtn) playBtn.hidden = false; }
            }
          });
        });
      }).catch(function () { return makeFallback(); });
      return creating;
    }

    if (soundBtn) soundBtn.addEventListener('click', function () {
      var on = soundBtn.getAttribute('aria-pressed') !== 'true';
      wanted = true; visible = true; forceReveal = true;
      create().then(function () { setSound(on); sync(); });
    });
    /* 2026-09-22: userPaused = false is kell — [data-tn-vh-noauto] módban a userPaused true-val indul, és a
       sync() enélkül azonnal megállította a kattintásra indított videót (a gomb semmit nem csinált). */
    if (playBtn) playBtn.addEventListener('click', function () {
      wanted = true; visible = true; forceReveal = true; userPaused = false;
      vh.classList.remove('is-user-paused');
      create().then(sync);
    });
    if ((!autoplayOK || noAuto) && playBtn) playBtn.hidden = false;

    /* kattintás (vagy Enter/Szóköz) a videón: megállítás / újraindítás — tulaj 09-19 */
    function toggle() {
      if (!ctl) { wanted = true; visible = true; userPaused = false; forceReveal = true; create().then(sync); return; }
      if (playing) { userPaused = true; vh.classList.add('is-user-paused'); ctl.pause(); }
      else { userPaused = false; wanted = true; visible = true; forceReveal = true; vh.classList.remove('is-user-paused'); sync(); }
    }
    vh.addEventListener('click', function (e) { if (e.target.closest('.pd-vh__tools')) return; toggle(); });
    vh.addEventListener('keydown', function (e) { if (e.target !== vh) return; if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });

    document.addEventListener('visibilitychange', function () { if (!document.hidden && autoplayOK) create().then(sync); else sync(); });

    function setVisible(v) {
      visible = v;
      clearTimeout(awayTimer);
      if (v) { awayLong = false; }
      else { awayTimer = setTimeout(function () { awayLong = true; sync(); }, AWAY_MS); }
      sync();
    }
    function inView(margin) {
      var r = vh.getBoundingClientRect();
      var H = window.innerHeight || document.documentElement.clientHeight;
      return r.bottom > -margin && r.top < H + margin;
    }
    function ratioVisible() {
      var r = vh.getBoundingClientRect();
      var H = window.innerHeight || document.documentElement.clientHeight;
      var vis = Math.min(r.bottom, H) - Math.max(r.top, 0);
      return r.height > 0 ? Math.max(0, vis) / r.height : 0;
    }
    /* létrehozás + indítás a poszter mögött már PREROLL px-re a látótér előtt: mire a szakasz a képernyőre ér, a videó MÁR megy */
    if ('IntersectionObserver' in window) {
      var near = new IntersectionObserver(function (en) {
        if (en.some(function (x) { return x.isIntersecting; })) { near.disconnect(); if (autoplayOK) create().then(sync); }
      }, { rootMargin: PREROLL + 'px 0px' });
      near.observe(vh);
      var io = new IntersectionObserver(function (en) {
        setVisible(en.some(function (x) { return x.isIntersecting; }));
      }, { threshold: 0.12 });
      io.observe(vh);
    }
    /* Tartalék az observer mellé: közvetlen mérés induláskor és görgetéskor */
    function measure() {
      if (!autoplayOK) return;
      if (inView(PREROLL)) create().then(function () { var v = ratioVisible() >= 0.12; if (v !== visible) setVisible(v); else sync(); });
    }
    measure();
    var scrollT = null;
    window.addEventListener('scroll', function () { clearTimeout(scrollT); scrollT = setTimeout(measure, 150); }, { passive: true });
  }

  function init(root, opts) {
    if (!root || root.__tnBrand) return;
    root.__tnBrand = true;
    var embedded = !!(opts && opts.embedded) || !!root.closest('[data-tn-brand-details]');
    if (embedded) {
      /* az Android-lap saját [data-pd] gyökere és #tn-product-desc-je marad az egyetlen */
      root.removeAttribute('data-pd');
      root.removeAttribute('id');
      [].forEach.call(root.querySelectorAll('[data-tn-brand-back],[data-tn-brand-full]'), function (a) { a.hidden = false; });
    }
    var vh = root.querySelector('[data-tn-vh]');
    if (vh) initHero(vh);
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-tn-brand-buy]');
      if (!b) return;
      e.preventDefault();
      var box = document.querySelector('.ap-buybox') || document.querySelector('form[action*="/cart/add"]') || document.querySelector('[data-tn-pio]');
      if (box) window.scrollTo({ top: box.getBoundingClientRect().top + window.pageYOffset - 16, behavior: 'smooth' });
    });
  }

  window.TNBrand = { init: init };

  function auto() {
    [].forEach.call(document.querySelectorAll('[data-tn-brand-root]'), function (r) {
      if (!r.closest('[data-tn-brand-details]')) init(r, { embedded: false });
    });
    /* önálló videó-hero (snippets/tn-video-hero) a sima terméklapokon */
    [].forEach.call(document.querySelectorAll('[data-tn-vh]'), function (vh) {
      if (!vh.closest('[data-tn-brand-root]')) initHero(vh);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', auto);
  else auto();
})();
